import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle, ArrowRight, ShoppingBag } from "lucide-react";

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // If Stripe sent us back with a product reference we can link back to it
  // Stripe Payment Links don't include product context on cancel, but our
  // dynamic checkout passes product_id in the cancel_url if we wire it up.
  const productId = searchParams.get("product_id");

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 sm:px-6"
      style={{ paddingTop: 80, paddingBottom: 60, background: "hsl(var(--background))" }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          background: "#fff",
          borderRadius: 20,
          border: "1px solid hsl(var(--border))",
          padding: "44px 40px",
          textAlign: "center",
          boxShadow: "0 12px 60px rgba(0,0,0,0.05)",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: 76,
            height: 76,
            borderRadius: "50%",
            background: "#f9fafb",
            border: "2px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 28px",
          }}
        >
          <XCircle style={{ height: 38, width: 38, color: "#9ca3af" }} />
        </div>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Oswald', sans-serif",
            fontWeight: 600,
            fontSize: "1.85rem",
            color: "hsl(var(--foreground))",
            letterSpacing: "-0.01em",
            lineHeight: 1.15,
            margin: "0 0 14px",
          }}
        >
          Payment Cancelled
        </h1>

        <p
          style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: 14,
            color: "hsl(var(--muted-foreground))",
            lineHeight: 1.65,
            margin: "0 0 28px",
          }}
        >
          No worries — your checkout was cancelled and no charge was made.
          You can return to the shop or go back to the product whenever you're ready.
        </p>

        {/* CTA: back to product if we have the id, otherwise shop */}
        <button
          onClick={() => navigate(productId ? `/product/${productId}` : "/shop")}
          style={{
            width: "100%",
            height: 50,
            borderRadius: 12,
            background: "linear-gradient(135deg, #6a00f4, #d100d1)",
            color: "#fff",
            fontFamily: "'Manrope', sans-serif",
            fontWeight: 700,
            fontSize: 14,
            letterSpacing: "0.02em",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            boxShadow: "0 4px 20px rgba(106,0,244,0.25)",
            marginBottom: 10,
            transition: "transform 0.15s, box-shadow 0.15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 28px rgba(106,0,244,0.35)"; }}
          onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = "0 4px 20px rgba(106,0,244,0.25)"; }}
        >
          <ShoppingBag size={16} />
          {productId ? "Back to Product" : "Browse Machines"}
        </button>

        <button
          onClick={() => navigate("/")}
          style={{
            width: "100%",
            height: 46,
            borderRadius: 12,
            background: "transparent",
            color: "hsl(var(--muted-foreground))",
            fontFamily: "'Manrope', sans-serif",
            fontWeight: 600,
            fontSize: 13,
            border: "1px solid hsl(var(--border))",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            transition: "border-color 0.15s, color 0.15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = "#6a00f4"; e.currentTarget.style.color = "#6a00f4"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "hsl(var(--border))"; e.currentTarget.style.color = "hsl(var(--muted-foreground))"; }}
        >
          Back to Home <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
}
